import AdminUserInvoice from 'components/Admin/UserInvoice/AdminUserInvoice';

const AdminInvoicePage = () => {
	return <AdminUserInvoice />;
};

export default AdminInvoicePage;
